import React, {useState, useRef, useEffect} from 'react';

import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({onSearch, placeholder = 'Search...'}) => {
    const [value, setValue] = useState('');
    const timerRef = useRef(null);

    useEffect(() => () => clearTimeout(timerRef.current), []);

    const handleChange = (e) => {
        const query = e.target.value;
        setValue(query);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => onSearch(query), 300);
    };

    return (
        <div className="flex items-center gap-2 mx-4 mb-3 px-3 py-2 border border-panels-normal rounded-input bg-background-normal">
            <SearchIcon style={{fontSize: 18, color: 'var(--main-light-color)'}} />
            <input
                data-testid="access-search-input"
                className="flex-1 text-sm bg-transparent outline-none text-main-normal placeholder-main-disabled"
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
            />
        </div>
    );
};

export default SearchBar;
